import React from "react";
import IntroSection from "../components/IntroSection";

import ScopingSolution from "../components/ScopingSolution";
import BlueSectionDivider from "../components/BlueSectionDivider";
import ScopingProcess from "../components/ScopingProcess";

import CustomerTestimonials from "../components/CustomerTestimonials";
import ScopingBenefits from "../components/ScopingBenefits";
import CertificateSection from "../components/CertificateSection";
import CountriesSection from "../components/CountriesSection";
import TeamSection from "../components/TeamSection";
import WhyUsSection from "../components/WhyUsSection";
import WorkingModelSection from "../components/WorkingModelSection";
import TechStackSection from "../components/TechStackSection";
import ScopingFAQ from "../components/ScopingFAQ";
import ScopingResources from "../components/ScopingResources";
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";

const ScopingSession = () => {
  return (
    <div>
<IntroSection title = "SCOPING SESSION" paragraph = "From a product idea to a business concept, we help you build a solid roadmap." backgroundImage="/images/ss-bg.webp"/>
<ScopingSolution/>
<BlueSectionDivider/>
<ScopingProcess/>

<ScopingBenefits/>

<BlueSectionDivider/>
<CountriesSection/>
<BlueSectionDivider/>
<TeamSection/>
<WhyUsSection/>
<WorkingModelSection/>
<TechStackSection/>
<BlueSectionDivider/>
<ScopingFAQ/>
<BlueSectionDivider/>

<ContactSection backgroundColor="#057af0ff"/>
<Footer/>
    </div>
  )};
  export default ScopingSession;